export enum ReviewFileStatus {
  Open,
  Closed,
  Accepted
}
